// --- Dependencies -------------------------------------------------------------------------------
import { create } from "zustand";
import { persist } from "zustand/middleware";
// --- Our Modules --------------------------------------------------------------------------------
import type { TyLang } from "@/types";
// --- Logic --------------------------------------------------------------------------------------
type TyLangStore = { lang: TyLang | null; setLang: (lang: TyLang) => void };

const useLang = create<TyLangStore>()(
    persist(
        (set) => ({
            lang: null,
            setLang: (lang) => set({ lang }),
        }),
        { name: "lang" }
    )
);

export default useLang;
